import { OrderFormContent } from '@/components/Forms/OrderForm';
import initOrderFormModal from '../shared/orderFormModal';
import initSliderCards from '../shared/sliderCards';
import initSearchDesktop from './searchDesktop';
import initSliderHome from './slider';

interface HomeConfig {
  home: {
    slider: string;
    translations: {
      sale: string;
      rental: string
    };
    cities: {
      sale: Array<{
        id: number;
        name: string;
        slug: string
      }>;
      rental: Array<{
        id: number;
        name: string;
        slug: string
      }>;
    };
    sliders: Array<{
      id: string;
      count: number
    }>;
    order: {
      root: string;
      button: string;
      content: OrderFormContent;
    };
  };
  lang: string;
}

export default ({
  home,
  lang
}: HomeConfig): void => {
  initSliderHome(home.slider);

  initSearchDesktop(lang, home.translations, home.cities.sale, home.cities.rental);

  home.sliders.forEach((slider) => {
    initSliderCards(slider.id, slider.count);
  });

  const onSuccess = () => {
    if (typeof gtag === 'function') {
      gtag('event', 'send_request', {
        event_category: 'home'
      });
    }
  };

  initOrderFormModal(home.order, onSuccess);
};
